import { axiosPath, coreInstance, backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    weserve_bank: [],
    bank_list: []
  },
  mutations: {
    getWeserveBank(state, data) {
      state.weserve_bank = data;
    },
    getBankList(state, data) {
      state.bank_list = data;
    },
    addBankAccount(state, data) {
      state.weserve_bank.push(data);
    }
  },
  actions: {
    async changeStatusBank(
      { commit, state, dispatch, rootState },
      { bank_id, bank_status }
    ) {
      let url = rootState.api_urls.fetchWeserveBank_changeStatusBank + bank_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: { bank_status } },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return res;
      }
    },
    async delBankAccount({ commit, state, dispatch, rootState }, bank_id) {
      let url = rootState.api_urls.fetchWeserveBank_delBankAccount + bank_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getWeserveBank", res);
        return 2;
      }
    },
    async editBankAccount({ commit, state, dispatch, rootState }, form) {
      let url = rootState.api_urls.fetchWeserveBank_editBankAccount;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getWeserveBank", res);
        return 2;
      }
    },
    async addBankAccount({ commit, state, dispatch, rootState }, form) {
      let url = rootState.api_urls.fetchWeserveBank_addBankAccount;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getWeserveBank", res);
        return 2;
      }
    },
    async getWeserveBank({ commit, state, dispatch, rootState }) {
      let url = rootState.api_urls.fetchWeserveBank_getWeserveBank;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return {};
      } else {
        commit("getWeserveBank", res);
      }
    },
    async getBankList({ commit, state, dispatch, rootState }) {
      let url = backendVersion.version + "/Office/Setbank/";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getBankList", res);
      }
    }
  }
};
